
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { reorderhistory } from "@/api/reorder";

export default defineComponent({
  name: "reorder",
  data() {
    return {
      list: [],
      pagination: {
        total: 0,
        per_page: 10,
        current_page: 1,
        last_page: 0,
        from: 1,
        to: 12,
      },
      loading: true,
    };
  },
  mounted() {
    this.reorderhistory();
  },
  methods: {
    async reorderhistory() {
      this.loading = true;
      const response = await reorderhistory(1);
      this.list = response.data.pageList;
      this.pagination = response.data.pagination;
      this.loading = false;
    },
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      tabIndex.value = parseInt(localStorage.getItem("reorderTab") || "0");
      setCurrentPageTitle("Reorder");
    });
  },
});
